import axios from "axios";
import http from "@/api/http/http";

export default {
  list(params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    const payloadString = http.getPayloadString(params)
    axios.get(`${process.env.VUE_APP_API}/admin/payment-link/list?${payloadString}`, header)
      .then(cb)
      .catch(errCb)
  },
  delete (params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    axios.delete(`${process.env.VUE_APP_API}/admin/payment-link/${params.id}`, header)
      .then(cb)
      .catch(errCb)
  },
  detail (params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    axios.get(`${process.env.VUE_APP_API}/admin/payment-link/${params.id}`, header)
      .then(cb)
      .catch(errCb)
  },
  save (params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    axios.post(`${process.env.VUE_APP_API}/admin/payment-link`, params, header)
      .then(cb)
      .catch(errCb)
  },
  update (params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    axios.put(`${process.env.VUE_APP_API}/admin/payment-link/${params.id}`, params, header)
      .then(cb)
      .catch(errCb)
  }
}